import {
  CountryNames,
  OrganizationCountry,
  ORGANIZATION_COUNTRY_MAP,
  convertCountryNameToCountryCode,
  resolveRegionCode,
} from "@simplyk/common";
import { useSearchParams } from "next/navigation";

export const getDefaultCountryRegion = ({
  emailIdQueryParam,
  organizationCountry,
  organizationRegion,
  ...addressQueryParams
}: {
  emailIdQueryParam?: string | null;
  countryQueryParam?: string | null;
  regionQueryParam?: string | null;
  stateQueryParam?: string | null;
  organizationCountry?: OrganizationCountry;
  organizationRegion?: string | null;
}) => {
  const { countryQueryParam, regionQueryParam, stateQueryParam } = emailIdQueryParam ? {} : addressQueryParams;
  const defaultCountry = (
    countryQueryParam || organizationCountry
      ? ORGANIZATION_COUNTRY_MAP[organizationCountry!].countryName
      : CountryNames.Canada
  ) as CountryNames;

  const resolvedCountryCode =
    (countryQueryParam ? convertCountryNameToCountryCode(countryQueryParam as CountryNames) : undefined) ??
    (organizationCountry ? ORGANIZATION_COUNTRY_MAP[organizationCountry].countryCode : undefined);

  return {
    defaultCountry,
    defaultRegion:
      resolveRegionCode(resolvedCountryCode, regionQueryParam || stateQueryParam || organizationRegion) ?? "",
  };
};

export const useDefaultCountryRegion = (organization: { country: OrganizationCountry; region?: string | null }) => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());

  return getDefaultCountryRegion({
    emailIdQueryParam: query.emailId ?? null,
    countryQueryParam: query.country ?? null,
    regionQueryParam: query.region ?? null,
    stateQueryParam: query.state ?? null,
    organizationCountry: organization.country,
    organizationRegion: organization.region,
  });
};
